var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {'status-indicator': true}, _obj[_vm.type] = true, _obj )},[_c('span',{class:"status-icon"}),_c('span',{class:("status-text align-" + _vm.align)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }